/**
 * Refresh Wallet Transactions UseCase
 * Flutter source: wallet_screen.dart - _refreshTransactions
 *
 * Fetches newer wallet transactions since the given timestamp.
 */
import { WalletService } from '@/domain/services/wallet/walletService';
import type { AppTransactionEntity } from '@/domain/entities/transaction/appTransactionEntity';
import { SERVER_FETCH_CONSTANTS } from '@/domain/constants/serverFetchConstants';

export class RefreshWalletTransactionsUseCase {
  private walletService: WalletService;

  constructor(walletService: WalletService = WalletService.getInstance()) {
    this.walletService = walletService;
  }

  async execute(
    afterTimestamp: number,
    limit?: number
  ): Promise<{ transactions: AppTransactionEntity[]; hasMore: boolean }> {
    return this.walletService.refreshTransactions(
      limit ?? SERVER_FETCH_CONSTANTS.DEFAULT_LIMIT,
      afterTimestamp
    );
  }
}
